"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolanaSignTransaction = void 0;
/** Name of the feature. */
exports.SolanaSignTransaction = 'solana:signTransaction';
//# sourceMappingURL=signTransaction.js.map